// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-close-userImg{width:30px;height:30px;margin-top:70px}.user-ctn{padding:15px 20px;position:relative}#app{height:100%}", ""]);
// Exports
module.exports = exports;
